var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-grow-1 align-items-center text-center"},[_c('p',{staticClass:"mt0 mb40 fz22"},[_vm._v(_vm._s(_vm.viewData.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }